// generated from 4 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const totalOrdersFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("total_orders_filter"),
  comparison_key: z.enum(["1", "3"]),
  display_name: z.string(),
  raw_value: z.literal(0),
  value: z.literal(0),
  varies_by_app_group: z.literal(false),
});
